// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hDVo","colMin":"styles_colMin__12h4L"};